import React, { useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { Box, makeStyles } from "@material-ui/core";
import AuthContext from "connections/auth/AuthProvider.js";

// ######### INTERNAL COMPONENTS
import SectionRouteDetail from "./SectionRouteDetail";

// ######### API
import { getModelDimensions } from "../../viewServices/apiCalls";

// ######### STYLES
const modelingRouteStyle = () => ({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    backgroundColor: "#ffffff",
  },
});

// ######### COMPONENT
export default function TabModelingRoute({
  selectedVariant: selectedVariantFromParent,
  inputColumns,
}) {
  const { userDetails } = useContext(AuthContext);
  const clientColor = userDetails?.implementation_color || "#1976d2";
  const useStyles = makeStyles(modelingRouteStyle);
  const classes = useStyles();

  const [dimensionsData, setDimensionsData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch model dimensions from API
  useEffect(() => {
    const fetchDimensions = async () => {
      setIsLoading(true);
      try {
        const data = await getModelDimensions("model01");
        console.log("📊 Model Dimensions Data:", data);
        setDimensionsData(data);
      } catch (error) {
        console.error("Error fetching model dimensions:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchDimensions();
  }, []);

  // Use variant from parent (DrawerFileIngestion)
  const selectedVariantData = selectedVariantFromParent
    ? dimensionsData?.[selectedVariantFromParent]
    : null;

  return (
    <Box className={classes.container}>
      <SectionRouteDetail
        variantData={selectedVariantData}
        clientColor={clientColor}
        isLoading={isLoading}
        inputColumns={inputColumns}
      />
    </Box>
  );
}

// ######### PROPTYPES
TabModelingRoute.propTypes = {
  selectedInputTable: PropTypes.string,
  inputMetadata: PropTypes.object,
  inputColumns: PropTypes.object,
  userDetails: PropTypes.object,
  selectedVariant: PropTypes.number,
};
